import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import * as utils from '@utils'
import { FormControlLabel, Checkbox } from '@material-ui/core'

class CompleteDecimal extends React.Component {
  constructor(props) {
    super(props)
    this.t = (key, options) => {
      return utils.t(key, 'CompleteDecimal', options)
    }
  }

  render() {
    return (
      <>
        <FormControlLabel
          control={
            <Checkbox
              checked={this.props.auth.isCompleteDecimal}
              onChange={(event) => {
                this.props.completeDecimal(event.target.checked)
              }}
              color="primary"
            />
          }
          label={this.t('showCompleteDecimal')}
          className={this.props.classes.labelMarginClear}
        />
      </>
    )
  }
}

CompleteDecimal.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  auth: PropTypes.object,
  completeDecimal: PropTypes.func,
}

const styles = () => {
  return {
    labelMarginClear: {
      margin: 0,
    }
  }
}

export default hoc(styles)(CompleteDecimal)
